var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-camera 1",
    clipPath: "url(#clip0_12076_8295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0006 5.95337V18.05L17.5291 14.5164H17.4648V9.48704H17.5291L24.0006 5.95337Z",
    fill: "#00ACEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4643 14.5162V17.2259C17.4643 18.3988 16.5133 19.3498 15.3404 19.3498H2.12389C0.950982 19.3498 0 18.3988 0 17.2259V6.74328C0 5.57037 0.950982 4.61938 2.12389 4.61938H15.3404C16.5133 4.61938 17.4643 5.57037 17.4643 6.74328V14.5162Z",
    fill: "#00EFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12076_8295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.ae4f18c5293ae5f340cbc12ecf33f23b.svg";
export { ForwardRef as ReactComponent };